import React from 'react';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import clsx from 'clsx';
import _ from 'lodash';

const RadioGroupBtn = (props) => {
  const {
    labelName,
    optionList,
    defaultValue,
    filterAction,
    value,
    rebateprgcustomcls,
    applyStyle,
  } = props;
  return (
    <div
      className={
        rebateprgcustomcls ? 'form-wrapper db mt-2 pb-3' : 'form-wrapper db'
      }
    >
      <div className="sub-radio no-margin">
        <FormControl>
          <RadioGroup
            row
            // aria-labelledby={_.kebabCase(labelName) + '-demo-row-radio-buttons-group-label'}
            name={`${_.kebabCase(labelName)}-row-radio-buttons-group`}
            defaultValue={defaultValue}
            value={value || defaultValue}
            data-testid="radio-box-group-control"
          >
            {!_.isEmpty(optionList)
              ? optionList &&
                optionList?.map((v, i) => (
                  <FormControlLabel
                    value={v.value}
                    control={
                      <Radio
                        onChange={(e) => filterAction(v.value)}
                        data-testid="radio-box-change"
                      />
                    }
                    disabled={v.disabled ? v.disabled : false}
                    label={v.name}
                    key={v.value && _.kebabCase(v.value)}
                    data-testid="radio-box-change-control"
                    style={
                      v.name === 'State' && applyStyle
                        ? { marginRight: '44px' }
                        : {}
                    }
                  />
                ))
              : null}
          </RadioGroup>
        </FormControl>
      </div>
    </div>
  );
};

function RadioGroupComponent(props) {
  const {
    labelName,
    required,
    reqColor,
    viewBorder = true,
    viewTitle = true,
    rebateprgcustomcls,
    applyStyle = false,
  } = props;

  return (
    <>
      {viewBorder ? (
        <fieldset
          data-testid="radio-box-component"
          className={clsx(
            'radioBtnGroup custom-fieldset h-100',
            labelName === 'Select By' && 'modified-radio-group'
          )}
        >
          {viewTitle && (
            <legend className="same-font-family">
              {labelName}{' '}
              <span className={reqColor || required ? 'mandatory' : ''}>
                {required ? '*' : ''}
              </span>{' '}
            </legend>
          )}
          <RadioGroupBtn {...props} />
        </fieldset>
      ) : (
        <>
          {viewTitle && (
            <legend className="same-font-family">
              {labelName}{' '}
              <span className={reqColor && 'mandatory'}>
                {required ? '*' : ''}
              </span>{' '}
            </legend>
          )}
          <RadioGroupBtn {...props} />
        </>
      )}
    </>
  );
}

export default RadioGroupComponent;
